import axios from "axios";
import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

const endpoint = "https://fumapi.testwebspace.co.uk";

function getStoredAuthToken() {
  return (
    window.localStorage.getItem("idToken") ||
    ""
  );
}

function authConfig() {
  const token = getStoredAuthToken();
  return {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
}

export const useGetRequest = (path) => {
  const [status, setStatus] = useState("idle");
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setStatus("fetching");
      const res = await axios.get(`${endpoint}/${path}`, authConfig());
      if (res) {
        setData(res.data);
      }
      setStatus("fetched");
    };

    console.log('authConfig', authConfig());

    fetchData();
  }, [path]);

  return { status, data };
};

export const sendPostRequest = async (path, params) => {
  const res = await axios.post(`${endpoint}/${path}`, params, authConfig());

  return res.data;
};

export const sendGetRequest = async (path, params) => {
  const res = await axios.get(`${endpoint}/${path}`, params, authConfig());

  return res.data;
};
